module.exports = {
      id: "newsletter-usage",
      viewBox: "0 0 26 23.012",
      url: "/" + "sprite-ab56b996b385d9abaaf31e01c38c81cd.svg#newsletter",
      toString: function () {
        return this.url;
      }
    }